<template>
    <div class="page bg-a-grey-f4f4f4 relative font-main-thai">
        <div class="p-5 lg:px-28">
            <img @click="clickBack()" class="cursor-pointer" src="@/assets/icon/ic-back.svg" alt="ic-back">
        </div>
        <div class="text-center text-tc-gray-3" v-if="state == 'init'" v-html="lbl.TransferMAAI.convert_tip"></div>
        <div class="text-center text-tc-gray-3" v-if="state == 'success'">{{lbl.TransferMAAI.convert_success}}</div>
        
        <div class="pt-3 pb-5 mx-auto">
            <div class="flex justify-center items-center gap-12">
                <img class="w-80px h-80px" src="@/assets/logo/logo-tip.svg" alt="logo-tip">
                <img class="w-5 h-8" src="@/assets/logo/logo-transfer.svg" alt="logo-transfer">
                <img class="w-80px h-80px rounded-20 shadow-sm" src="@/assets/logo/logo-maai-v2.png" alt="logo-maai">
            </div>
        </div>
        <div class="text-center">
            <div class="text-666666">{{lbl.TransferMAAI.your_tip_coin}}</div>
            <div class="text-666666 text-25">{{ FilterNumberFormat(userPoint) }}</div>
        </div>
        <div class="bg-white lg:mx-28 rounded-t-40 content-height mt-5">
            <div class="flex flex-col w-full h-full justify-between pt-8 px-6 pb-5 md:max-w-xl mx-auto" v-if="state == 'init'">
                <div class="text-center">
                    <div class="font-bold text-666666 text-16 pb-3">{{lbl.TransferMAAI.please_enter}}</div>
                    <input type="tel" 
                        class="w-full rounded-full border border-a-grey-aaaaaa text-666666 text-25 text-center py-4" 
                        v-model="inputPoint"
                        @input="onChange()"/>
                    <div class="pt-5">
                        <GreyBtn @click="clickClickTransfer()">{{lbl.TransferMAAI.Continue}}</GreyBtn>
                    </div>
                </div>
                <div class="flex justify-center">
                    <img src="@/assets/logo/logo-bzbs.svg" alt="logo-bzbs">
                </div>
            </div>
            <div class="flex flex-col w-full h-full justify-between pt-8 px-6 pb-5 md:max-w-xl mx-auto" v-if="state == 'success'">
                <div class="text-center"> 
                    <div class="pt-5">
                        <GreyBtn @click="clickGoHome()">{{lbl.TransferMAAI.back_home}}</GreyBtn>
                    </div>
                </div>
                <div class="flex justify-center">
                    <img src="@/assets/logo/logo-bzbs.svg" alt="logo-bzbs">
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// compoent
import GreyBtn from '@/components/Button/GreyBtn.vue';
// Util
import Util from '@/helper/Utility';
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
import AuthStatusMixin from "@/mixin/AuthStatusMixin"; 
import TransferMAAIService from '@/module/TransferMAAI/service/TransferMAAIService.js'  

export default {
    name: 'TransferMAAI',
    mixins: [AuthStatusMixin, ModalMixin, LocaleMixin],
    components: {
        GreyBtn
    },
    data() {
        return {
            state: "init", // init, success
            inputPoint: '',
            pointForTransfer: '',
            isMAAIMember: false,
        };
    },
    mounted: function() {
    },
    created: function() {
        this.init();
    },
    methods: {
        init: async function() {
            this.state = "init"; 
            
            this.loadingModal.show();
            await this.checkIsMAAI();
        },
        checkIsMAAI: function() {
            return new Promise((resolve) => {
                TransferMAAIService.checkIsMember().subscribe((res) => {
                    this.loadingModal.hide();
                    this.isMAAIMember = res.success; 
                    //this.isMAAIMember = false;
                    if (!this.isMAAIMember) {
                        window.location.href = "/home";
                    }
                    resolve(res);
                }, (err) => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        clickBack: function() {
            this.$router.back();
        },
        clickGoHome: function() {
            this.$router.push({ name: 'Home' });
        },
        onChange: function() {
            let input = parseFloat(this.inputPoint.replace(/,/g, '')); // remove comma from input
            if (input > this.userPoint) {
                input = this.userPoint;
            }
            this.pointForTransfer = input; // points without comma
            input = Util.formatNum(input, 0);
            console.log("input", input);
            this.inputPoint = input;
        },
        clickClickTransfer: function() {
            this.confirmTransferMAAIModal
                .clearModal()
                // .setUserPoints(this.userPoint)
                .setUserPoints(this.pointForTransfer)
                .setTransferPoints(this.pointForTransfer)
                .show()
            this.confirmTransferMAAIModal.onClickOk(async () => {  
                this.loadingModal.show();
                await this.transferMAAI(this.pointForTransfer)  
                this.loadingModal.hide();
            })
        },
        transferMAAI: function(point) { 
            return new Promise((resolve) => {
                TransferMAAIService.pointTranfer(point).subscribe((res) => { 
                    console.log("transfer", res); 
                    if (res.success){
                        //success
                        // update point 
                        this.AccountStore.methods.apiUpdatePoint().then(()=>{ 
                            this.state = "success";
                            resolve(true);
                        });
                        return;
                    } 
                    resolve(false); 
                    
                }, (err) => {
                    resolve(false); 
                    /*
                        error แบ่ง 2 เคส
                    1 error จากบ้านเราจะเป็น 400,404 จะมี messageแจ้งดีเทล ถ้าเคสนี้ ขึ้นpop up something wrong ให้ทำการเรียกเส้น transfer อีกรอบ โดยดึงพ้อยล่าสุดที่ user กรอกมาใส่ แล้วทำการtransfer อีกครั้ง
                    2 error จาก maai จะเป็น 409 message จะแสดง error จากฝั่งเค้ามา ซึ่งเคสนี้จะขึ้นหน้า popup contact call center ค่ะ
                    */
                    // error bzb
                    //this.transferFailModal.show()

                    // error MAAI
                    //this.contractCallCenterModal.show() 
                    
                    if (err.code == 409) {
                        this.contractCallCenterModal.show()
                    }
                    else if (err.code == 400 || err.code == 404) {
                        this.transferFailModal.show()
                    }
                    else { 
                        this.errorApi(err);
                    }
                });
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.content-height {
    height: calc(100vh - 294px);
}
</style>